global.constant = {
    /* baseUrl:"http://121.43.155.171/api/",
    uploadImage:"http://121.43.155.171/api/download/",
    uploadFile:"http://121.43.155.171/api/users/student/import",
    getFile:"http://121.43.155.171/api/users/student/template" */
    /*baseUrl:"http://127.0.0.1/api/",
    uploadImage:"http://127.0.0.1/api/download/",
    uploadFile:"http://127.0.0.1/api/users/student/import",
    getFile:"http://127.0.0.1/api/users/student/template"*/
    /*baseUrl:"http://101.132.242.111/api/",
    uploadImage:"http://101.132.242.111/api/download/",
    uploadFile:"http://101.132.242.111/api/users/student/import",
    getFile:"http://101.132.242.111/api/users/student/template"*/
    /* baseUrl:"http://192.168.16.68:8000/api/",
    uploadImage:"http://192.168.16.68:8000/api/download/",
    uploadFile:"http://192.168.16.68:8000/api/users/student/import",
    getFile:"http://192.168.16.68:8000/api/users/student/template" */
    baseUrl:"/api/",
    uploadImage:"/api/download/",
    uploadFile:"/api/users/student/import",
    getFile:"/api/users/student/template"
};